import React, { Fragment } from "react";

import * as R from "ramda";

import * as PropTypes from "prop-types";

import { translate } from "react-i18next";

import { compose, withProps } from "recompose";

import camelCase from "camel-case";

import { defaultTheme, themeColor } from "src/styles";
import { shortenLocaleName } from "src/utils";

import {
  Box,
  Content,
  H1,
  PageMenu,
  RelatedLinks,
  Share,
} from "src/components";

import Layout from "src/components/Layout";

import { isActiveArticle } from "src/components/Embed";

// Remove the padding from the first Body module if present
const withoutTopBodyPadding = R.adjust(
  R.when(R.propEq("__typename", "ContentfulBody"), R.assoc("pt", 0)),
  0
);

const getAlerts = R.unless(
  R.isNil,
  R.filter(R.allPass([R.propEq("embedStyle", "Alert"), isActiveArticle]))
);

const TopPageMenu = ({ page, theme }) => (
  <PageMenu
    page={page}
    title={null}
    theme={theme}
    mb={2}
    px={0}
    borderBottom={true}
    borderWidth={1}
    borderColor="divider"
    display={["block", "block", "block", "none"]}
    listProps={{
      flexDirection: "row",
      style: {
        overflowX: "auto",
      },
      mt: 0,
    }}
    itemProps={{
      style: {
        whiteSpace: "nowrap",
      },
      ml: 3,
      mb: 2,
      fontSize: 2,
    }}
  />
);

const Page = ({
  siteData,
  data,
  t,
  breadcrumb,
  headerImages,
  pathContext,
  ...props
}) => {
  if (!data) {
    return null;
  }

  const {
    contentfulPage: {
      fullUrl,
      title: pageTitle,
      layout: layoutName,
      metaDescription,
      headerContent,
      content,
      theme = defaultTheme,
      bottomContent,
      sidebarContent,
      relatedLinks,
      articles,
      showSharingIcons = false,
      suppressSidebar = false,
      suppressBreadcrumb = false,
      suppressPageTitle = false,
      suppressNcuaLogo = false,
      suppressEhlLogo = false,
    },
  } = data;

  const pageDescription = metaDescription && metaDescription.metaDescription;
  const alerts = getAlerts(articles);

  const layout = layoutName ? camelCase(layoutName) : undefined;

  const tealiumTag = `
  (function(a,b,c,d){
    a="https://tags.tiqcdn.com/utag/adtaxi/fcfcu.com/prod/utag.js";
    b=document;c="script";d=b.createElement(c);d.src=a;d.type="text/java"+c;d.async=true;
    a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
    })();
`;

  const universalPixel = `ttd_dom_ready( function() {
                if (typeof TTDUniversalPixelApi === 'function') {
                    var universalPixelApi = new TTDUniversalPixelApi();
                    universalPixelApi.init("010w9rb", ["58uuxig"], "https://insight.adsrvr.org/track/up");
                }
            });`;

  const secondaryPixel = `var $wc_load=function(a){return  JSON.parse(JSON.stringify(a))},$wc_leads=$wc_leads||{doc:{url:$wc_load(document.URL),ref:$wc_load(document.referrer),search:$wc_load(location.search),hash:$wc_load(location.hash)}};`;

  return (
    <Layout
      data={data}
      locale={shortenLocaleName(pathContext.locale)}
      alerts={alerts}
      suppressEhlLogo={suppressEhlLogo}
      suppressNcuaLogo={suppressNcuaLogo}
      title={pageTitle}
      layout={layout}
      description={pageDescription}
      headerImages={headerImages}
      theme={theme}
      breadcrumb={!suppressBreadcrumb && breadcrumb}
      pageTitle={pageTitle}
      renderAboveBreadcrumb={() => (
        <Fragment>
          {headerContent && (
            <Content
              content={headerContent}
              theme={theme}
              siteData={siteData}
            />
          )}
          {!suppressSidebar && (
            <TopPageMenu page={data.contentfulPage} theme={theme} />
          )}
        </Fragment>
      )}
      renderSidebar={
        !suppressSidebar &&
        (() => (
          <Fragment>
            <PageMenu
              page={data.contentfulPage}
              title={t("layout.menuTitle")}
              theme={theme}
              mb={4}
              display={["none", "none", "none", "block"]}
            />
            {showSharingIcons && (
              <Share url={fullUrl} mb={4} description={pageDescription} />
            )}
            {relatedLinks && (
              <RelatedLinks links={relatedLinks} theme={theme} />
            )}
            {sidebarContent && (
              <Box mt={3}>
                <Content
                  content={sidebarContent}
                  theme={theme}
                  siteData={siteData}
                  condensed={true}
                  pageData={data}
                />
              </Box>
            )}
          </Fragment>
        ))
      }
      renderBottomContent={
        bottomContent &&
        (() => (
          <Content
            content={bottomContent}
            theme={theme}
            siteData={siteData}
            pageData={data}
          />
        ))
      }
    >
      {!suppressPageTitle && (
        <H1 color={themeColor(theme)} px={[3, 3, 4]} mt={2}>
          {pageTitle}
        </H1>
      )}
      {content && (
        <Content
          content={suppressPageTitle ? content : withoutTopBodyPadding(content)}
          theme={theme}
          siteData={siteData}
          pageData={data}
        />
      )}
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{ __html: tealiumTag }}
      />
      <script
        src="//rum-static.pingdom.net/pa-66cf9b411ec1ac0012000084.js"
        async
      ></script>
      <script
        src="https://js.adsrvr.org/up_loader.1.1.0.js"
        type="text/javascript"
      ></script>
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{ __html: universalPixel }}
      />
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{ __html: secondaryPixel }}
      ></script>
      <script src="//s.ksrndkehqnwntyxlhgto.com/140237.js"></script>
      <script id="facebook-pixel-script">
        {`!function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '427292227998029');
        fbq('track', 'PageView');`}
      </script>
      <noscript key="image" id="facebook-pixel-image">{`<img
          height="1"
          width="1"
          style="display:none"
          src="https://www.facebook.com/tr?id=427292227998029&ev=PageView&noscript=1"
        />`}</noscript>
      <noscript></noscript>
      <img
        height="1"
        width="1"
        style={{ borderStyle: "none" }}
        alt=""
        src="https://insight.adsrvr.org/track/pxl/?adv=010w9rb&ct=0:k5e2qdg&fmt=3"
      />
      <img
        height="1"
        width="1"
        style={{ borderStyle: "none" }}
        alt=""
        src="https://insight.adsrvr.org/track/pxl/?adv=010w9rb&ct=0:rsf10td&fmt=3"
      />
    </Layout>
  );
};

Page.propTypes = {
  data: PropTypes.object.isRequired,
};

const getHeaderImages = props => {
  const headerImages = R.path(
    ["data", "contentfulPage", "headerImages"],
    props
  );

  if (headerImages && headerImages.length) {
    return headerImages;
  }
};

export default compose(
  translate("translations"),
  withProps(props => ({
    siteData: {
      events: R.pipe(
        R.pathOr([], ["data", "allContentfulEvent", "edges"]),
        R.map(R.prop("node"))
      )(props),
    },
    breadcrumb: R.pathOr([], ["pathContext", "breadcrumb"], props),
    headerImages: getHeaderImages(props),
  }))
)(Page);

export const pageQuery = graphql`
  query pageQuery($id: String!, $locale: String!) {
    ...LayoutQuery
    allContentfulEvent(limit: 1000, filter: { node_locale: { eq: $locale } }) {
      edges {
        node {
          id
          name
          slug
          registrationConfirmation {
            childMarkdownRemark {
              html
            }
          }
          location {
            lon
            lat
          }
          eventDates {
            id
            startDate
            endDate
          }
        }
      }
    }
    contentfulPage(id: { eq: $id }) {
      id
      title
      url
      fullUrl
      theme
      layout
      metaDescription {
        metaDescription
      }
      headerImages {
        ...PhotoWithCaptionContents
      }
      headerContent {
        ...Module
      }
      content {
        ...ItemGroupContents
        ...ArticleEmbed
        ...PageEmbed
        ...Body
        ...Calculator
        ...BanzaiCalculator
        ...Module
      }
      sidebarContent {
        ...Body
        ...ItemGroupContents
        ...Module
      }
      relatedLinks {
        ...RelatedLink
      }
      bottomContent {
        ...Module
      }
      suppressSidebar
      suppressBreadcrumb
      suppressPageTitle
      suppressNcuaLogo
      suppressEhlLogo
      showSharingIcons
      ...PageMenuFragment
      # Alerts
      articles: article {
        ...ArticleEmbed
        archivePages {
          id
        }
        embedStyle
        publicationDate
        unpublishDate
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/page.js